var map = {
	"./10_avatar.png": 123,
	"./12_avatar.png": 124,
	"./13_avatar.png": 125,
	"./14_avatar.png": 126,
	"./15_avatar.png": 127,
	"./16_avatar.png": 128,
	"./17_avatar.png": 129,
	"./18_avatar.png": 130,
	"./19_avatar.png": 131,
	"./1_avatar.png": 132,
	"./20_avatar.png": 133,
	"./2_avatar.png": 134,
	"./3_avatar.png": 135,
	"./4_avatar.png": 136,
	"./5_avatar.png": 137,
	"./6_avatar.png": 138,
	"./7_avatar.png": 139,
	"./8_avatar.png": 140,
	"./9_avatar.png": 141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;